import React, { useEffect, useState } from "react";
import "./acknowledgement-modal.css";
import { defaultModalProps, Modal } from "../ModalComponent/Modal";

const defaultProps = {
  ...defaultModalProps,
  buttonText: "",
  onAcknowledge: () => {},
};

export function AcknowledgementModal(props = defaultProps) {
  return (
    <Modal {...props}>
      <div className="acknowledgement-modal-buttons">
        <button id={props.id + "-confirm-button"} className="standard-button" onClick={props.onAcknowledge}>
          {props.buttonText}
        </button>
      </div>
    </Modal>
  );
}
